import { IBiologicalModel } from 'app/shared/model/biological-model.model';

export interface IStorageSite {
  id?: number;
  name?: string;
  biologicalModels?: IBiologicalModel[] | null;
}

export const defaultValue: Readonly<IStorageSite> = {};
